<template>
    <div class="timeline">
        <div class="empty" v-show="!payload.length">
            {{ lang('no_events', 'timeline') }}
        </div>
        <ul v-show="payload.length">
            <li v-for="(entry, index) in payload">
                <div class="entry-left">
                    <span class="color-mark" :style="{background: '#' + color(index)}"></span>
                    <span>{{ entry.message }}</span>
                </div>
                <div class="entry-right">{{ dateFormat(entry.createdAt) }}</div>
            </li>
        </ul>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        props: {
            payload: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        mounted() {
            this.$emit('init');
        },
        methods: {
            dateFormat(date) {
                return moment(date).format('MMMM DD, YYYY')
            },
            color(index) {
                const colors = ['4D73BE', '7EAB55', 'B99130', 'F6C143', 'A3A3A3'];
                return colors[(index + 1) % colors.length - 1]
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../sass/_variables.scss";

    .timeline {
        min-height: 200px;

        ul {
            padding-top: 30px;
            position: relative;

            &::before {
                content: '';
                position: absolute;
                display: block;
                background-color: $primary-color;
                width: 1px;
                top: 48px;
                bottom: 13px;
                left: 18px;
            }
        }

        li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12.5px 0;
            color: #000;
            font-size: 19px;

            .color-mark {
                width: 36px;
                height: 36px;
                display: inline-block;
                background: blue;
                border-radius: 50%;
                margin-right: 10px;
                z-index: 2;
            }

            .entry-left {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
        }

        .empty {
            display: flex;
            font-size: 20px;
            color: #000;
            align-items: center;
            justify-content: center;
            height: 200px;
        }
    }
</style>
